import { AdvisorData } from "../../../../../lib/advisor/advisor.model";
import { StringHelper } from "../../../../../lib/helpers/string.helper";

export const getVerificationFailedGeneralMessage = (advisorData: AdvisorData): string =>
	`We were unable to verify your identity. To complete the verification process, please contact your Business Advisor${StringHelper.advisorContactFormat(advisorData)}for further assistance.`;

export const getVerificationFailedGeneralTitle = `Verification unsuccessful`;